import { FC } from 'react';
import Icon from 'components/Icons/Icon';
import { GetReadyToVoteItem } from './utils/getReadyToVoteBoxes';

interface DonationSectionProps {
  membershipMessage?: GetReadyToVoteItem | null;
}

const DonationSection: FC<DonationSectionProps> = ({ membershipMessage }) => {
  return (
    <section
      className="donation-section"
      aria-labelledby="donation-section-heading"
    >
      <div className="donation-section-stripes" aria-hidden="true">
        <span className="donation-section-stripe donation-section-stripe-gold" />
        <span className="donation-section-stripe donation-section-stripe-teal" />
      </div>
      <div className="donation-section-inner">
        <div className="donation-section-text">
          <span className="donation-section-eyebrow">Member Supported</span>
          <h2
            id="donation-section-heading"
            className="donation-section-heading"
          >
            {membershipMessage?.title || `Support The News You Can Use`}
          </h2>
          <p className="donation-section-copy">
            {membershipMessage?.description ||
              `MPR News is community supported public media. It’s free for
            everyone thanks to thousands of individuals who donate to it. Give
            today to power the news and information that keeps Minnesotans
            informed and connected.`}
          </p>
        </div>
        <div className="donation-section-actions">
          <a
            href={
              membershipMessage?.linkUrl || `https://support.mpr.org/news-web`
            }
            className="btn btn-primary donation-section-cta"
          >
            <Icon name="heart" />
            {membershipMessage?.buttonText || `Give Now`}
          </a>
          <span className="donation-section-note">Support MPR News today!</span>
        </div>
      </div>
    </section>
  );
};

export default DonationSection;
